import { render, staticRenderFns } from "./EventsIndexPage.vue?vue&type=template&id=3d690805&scoped=true"
import script from "./EventsIndexPage.vue?vue&type=script&lang=js"
export * from "./EventsIndexPage.vue?vue&type=script&lang=js"
import style0 from "./EventsIndexPage.vue?vue&type=style&index=0&id=3d690805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.20_css-loader@6.11.0_@rspack+core@1.5.0_@swc+h_83b9284dd63eedf3f9170fbde5313985/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d690805",
  null
  
)

export default component.exports